import { createSlice } from "@reduxjs/toolkit";

const consumerSlice = createSlice({
  name: "consumer",
  initialState: {
    consumerProfile: {},
  },
  reducers: {
    setConsumerProfile: (state, action) => {
      state.consumerProfile = action.payload;
    },
    // setProviderId: (state, action) => {
    //   state.providerId = action.payload;
    // },
  },
});

export const { setConsumerProfile } =
consumerSlice.actions;
export default consumerSlice.reducer;
